import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin, token } from '@zillow/constellation';

// @ts-expect-error
const getBorder = (props) => {
  if (props.isDragAccept) {
    return `2px solid ${props.theme.constellation.colors.brand}`;
  }
  if (props.isDragReject) {
    return `1px solid ${props.theme.constellation.colors.red600}`;
  }

  return `1px solid ${props.theme.constellation.colors.gray300}`;
};

export const Container = styled.div<{
  isDragAccept: boolean;
  isDisabled: boolean;
  isContainerSizeFixed: boolean;
  isSmallDropzone: boolean;
}>`
  text-align: center;
  align-items: center;
  background-color: ${({ isDragAccept, isDisabled }) => (isDragAccept || isDisabled) && token('colors.gray100')};
  border-radius: 4px;
  border: ${(props) => getBorder(props)};
  color: ${token('colors.textDark')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex-direction: column;
  flex: 1;
  height: ${({ isContainerSizeFixed }) => (isContainerSizeFixed ? '100px' : '100%')};
  justify-content: center;
  padding: ${spaceMixin('xs')};
  transition: border 0.24s ease-in-out;
  width: ${({ isContainerSizeFixed }) => (isContainerSizeFixed ? '100px' : '100%')};
  opacity: ${({ isDisabled }) => (isDisabled ? '.5' : '1')};

  ${mediaMixin(
    'md',
    css`
      min-height: ${({ isSmallDropzone }: { isSmallDropzone: boolean }) => (isSmallDropzone ? '90px' : '240px')};
    `,
  )};
`;
